export const PAGE_TITLE = {
  HOME: 'Home',

  NETWORK: 'Network',
  MY_NETWORK: 'My Network',
  PEOPLE_YOU_MAY_KNOW: 'People you may know',
  INBOX: 'Inbox',
  LOGOUT: 'Logout',
  ERROR_404: 'Page Not Found',
  REVIEWS: 'Reviews',
  JOBS: 'Jobs',
  PROJECTS: 'Projects',
  GLOBAL_SEARCH: 'Search for contacts, firms and reviews',

  ADD_RECOMMENDATION: 'Add Recommendation',
  ADD_REVIEW: 'Add Review',

  CANDIDATE_PROFILE: 'Profile',
  CANDIDATE_PREPARATORY: 'Preparatory',
  CANDIDATE_APTITUDE: 'Aptitude',
  CANDIDATE_ACCOUNT: 'Account',
  CANDIDATE_CONFIDENTIAL: 'Confidential',
  CANDIDATE_UPGRADE_PREMIUM: 'Premium',
  SUBSCRIPTION_CONFIRMATION: 'Thanks for subscribing',
  CANDIDATE_ACCOUNT_REGISTRATION: 'Registration',

  RECRUITER_MANAGE_CALENDAR: 'Calendar',
  RECRUITER_PURCHASE: 'Credits',

  SEARCH: 'Search',
  SEARCH_INBOUNDS: 'Inbounds',
  SEARCH_INBOUNDS_REQUIREMENTS: 'Requirements',
  SEARCH_SHORTLIST: 'My Shortlists',
  SEARCH_SUBSCRIPTION: 'Subscription Searches',
  SEARCH_RATED: 'Search Rated',
  SEARCH_PROCESS_MANAGE: 'Manage Process',
  SEARCH_PROCESS_ADD: 'Add Process',
  SEARCH_PROJECT_MANAGE: 'Manage Projects',
  SEARCH_PROJECT_ADD: 'Add Project',
  SEARCH_TEAM: 'Team',
  SHORTLIST_PROFESSIONALS: 'Shortlist professionals',
  MANAGE_EMAILS_TEMPLATES: 'Manage Emails Templates',

  CHECKOUT: 'Checkout',
  CHECKOUT_PREMIUM: 'Checkout',
  CHECKOUT_PREP: 'Checkout',
  CHECKOUT_PREMIUM_PREP: 'Checkout',
  CHECKOUT_INBOUNDS: 'Checkout',
  CHECKOUT_CREDIT: 'Checkout',
  CHECKOUT_CREDITS: 'Checkout',
};

export default PAGE_TITLE;
